import APIService from "@/services/APIService.js";

const apiCampanha = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/campanha"
});

export default {
  getAll(limit, page, filters) {
    return apiCampanha.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
  list(usuarios_id, sit_campanha) {
    return apiCampanha.get("", {
      params: {
        usuarios: usuarios_id,
        sit_campanha: sit_campanha
      }
    });
  }
};
